<template>
    <div></div>
</template>

<script>

export default {
	data() {
		return {
			email: "",
			password: ""
		};
	},
	methods: {
		redirect() {
			window.location.href='/pages/login';
		},
		logout() {
            localStorage.removeItem("userInfo");
            this.redirect();
		}
	},
	created() {
		console.log('dfdfd');
		this.logout();
	}
};
</script>

<style lang="scss">
#page-login {
	.social-login-buttons {
		.bg-facebook {
			background-color: #1551b1;
		}
		.bg-twitter {
			background-color: #00aaff;
		}
		.bg-google {
			background-color: #4285f4;
		}
		.bg-github {
			background-color: #333;
		}
	}
}
</style>
